import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAuthVendor } from '../store/reducers';

export const noVendorGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const store = inject(Store);
  const router = inject(Router);

  if (store.selectSignal(selectAuthVendor)()) {
    await router.navigate(['/reservations']);
    return false;
  }

  return true;
};
